import { useContext } from 'react';

import { CustomLabels, PortalConfigContext } from 'src/context';

export const useCustomizedLabels = (): KeysToSnakeCase<CustomLabels> => {
  const config = useContext(PortalConfigContext);

  // Default labels if clientTerm/companyTerm are not set
  let customLabels: KeysToSnakeCase<CustomLabels> = {
    client_one: 'Client',
    client_many: 'Clients',
    company_one: 'Company',
    company_many: 'Companies',
  };

  // Override client labels if clientTerm is set
  // or use the custom labels from the portal config if clientTerm is "Other"
  switch (config.features.customLabels?.clientTerm) {
    case 'Contact':
      customLabels = {
        ...customLabels,
        client_one: 'Contact',
        client_many: 'Contacts',
      };
      break;
    case 'Person':
      customLabels = {
        ...customLabels,
        client_one: 'Person',
        client_many: 'People',
      };
      break;
    case 'User':
      customLabels = {
        ...customLabels,
        client_one: 'User',
        client_many: 'Users',
      };
      break;
    case 'Other':
      customLabels = {
        ...customLabels,
        client_one:
          config.features.customLabels.clientOne ?? customLabels.client_one,
        client_many:
          config.features.customLabels.clientMany ?? customLabels.client_many,
      };
      break;
  }

  // Override company labels if companyTerm is set
  // or use the custom labels from the portal config if companyTerm is "Other"
  switch (config.features.customLabels?.companyTerm) {
    case 'Family':
      customLabels = {
        ...customLabels,
        company_one: 'Family',
        company_many: 'Families',
      };
      break;
    case 'Group':
      customLabels = {
        ...customLabels,
        company_one: 'Group',
        company_many: 'Groups',
      };
      break;
    case 'Space':
      customLabels = {
        ...customLabels,
        company_one: 'Space',
        company_many: 'Spaces',
      };
      break;
    case 'Other':
      customLabels = {
        ...customLabels,
        company_one:
          config.features.customLabels.companyOne ?? customLabels.company_one,
        company_many:
          config.features.customLabels.companyMany ?? customLabels.company_many,
      };
      break;
  }

  return customLabels;
};
